import React, { useState } from 'react';
import { Map, CheckCircle, WarningCircle } from 'iconoir-react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import BuscaEndereco from './BuscaEndereco';
import { adicionarEndereco } from '../services/api';
import './ModalMobile.css';
import './ButtonStyles.css';

function AdicionarEnderecoModal({ show, onHide, brand, onEnderecoAdicionado }) {
  const [enderecoSelecionado, setEnderecoSelecionado] = useState(null);
  const [complemento, setComplemento] = useState('');
  const [referencia, setReferencia] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleEnderecoSelected = (endereco) => {
    setEnderecoSelecionado(endereco);
    setError('');
  };

  const handleSalvar = async () => {
    if (!enderecoSelecionado) {
      setError('Selecione um endereço');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const token = localStorage.getItem('sitri_token');
      if (!token) {
        setError('Token não encontrado');
        return;
      }

      const dadosEndereco = {
        endereco: enderecoSelecionado.endereco,
        lat: enderecoSelecionado.lat,
        lng: enderecoSelecionado.lng,
        place_id: enderecoSelecionado.place_id,
        complemento: complemento.trim(),
        referencia: referencia.trim()
      };

      const resultado = await adicionarEndereco(token, dadosEndereco);
      
      if (resultado && resultado.success) {
        onEnderecoAdicionado();
        handleClose();
      } else {
        setError(resultado?.message || 'Erro ao salvar endereço');
      }
    } catch (error) {
      setError('Erro ao salvar endereço');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setEnderecoSelecionado(null);
    setComplemento('');
    setReferencia('');
    setError('');
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton style={{borderBottom:'1px solid #e5e7eb'}}>
        <Modal.Title style={{fontWeight:700, fontSize:'1.1rem', color:'#111827'}}>Adicionar Endereço</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{backgroundColor:'#f9fafb', padding:'20px'}}>
        {error && (
          <Alert variant="danger" className="py-2" style={{borderRadius:'12px', fontSize:'0.85rem'}}>
            <small>{error}</small>
          </Alert>
        )}

        <div className="mb-3">
          <label className="form-label" style={{fontSize:'0.85rem', color:'#6b7280', marginBottom:'8px', fontWeight:600}}>Endereço *</label>
          <BuscaEndereco 
            onSelected={handleEnderecoSelected}
            brand={brand}
          />
        </div>

        {enderecoSelecionado && (
          <>
            <div className="mb-3 p-3" style={{background:'#fff', border:'1px solid #e5e7eb', borderRadius:'12px', boxShadow:'0 1px 2px rgba(0,0,0,0.04)'}}>
              <div className="d-flex align-items-start" style={{gap:'12px'}}>
                <div style={{width:'36px', height:'36px', borderRadius:'8px', background:'#f9fafb', display:'flex', alignItems:'center', justifyContent:'center', border:'1px solid #e5e7eb', flexShrink:0}}>
                  <Map style={{color:'#6b7280'}} width="20" height="20" />
                </div>
                <div style={{flex:1}}>
                  <div style={{fontSize:'0.85rem', color:'#111827', fontWeight:500}}>{enderecoSelecionado.endereco}</div>
                </div>
              </div>
            </div>

            {enderecoSelecionado.entrega && (
              <div className="alert alert-success mb-3" style={{borderRadius:'12px', fontSize:'0.85rem', padding:'12px', display:'flex', alignItems:'center'}}>
                <CheckCircle className="me-2" />
                <strong>Endereço dentro da área de entrega!</strong>
              </div>
            )}

            {enderecoSelecionado.entrega === false && (
              <div className="alert alert-warning mb-3" style={{borderRadius:'12px', fontSize:'0.85rem', padding:'12px', display:'flex', alignItems:'center'}}>
                <WarningCircle className="me-2" />
                <strong>Endereço fora da área de entrega!</strong>
              </div>
            )}

            <div className="mb-3">
              <Form.Group>
                <Form.Label style={{fontSize:'0.85rem', color:'#6b7280', marginBottom:'8px', fontWeight:600}}>Complemento</Form.Label>
                <Form.Control
                  type="text"
                  value={complemento}
                  onChange={(e) => setComplemento(e.target.value)}
                  placeholder="Ex: Apto 3B do bloco J."
                  style={{
                    fontSize:'0.85rem',
                    padding:'10px 12px',
                    borderRadius:'12px',
                    border:'1px solid #e5e7eb',
                    backgroundColor:'#fff'
                  }}
                />
              </Form.Group>
            </div>

            <div className="mb-3">
              <Form.Group>
                <Form.Label style={{fontSize:'0.85rem', color:'#6b7280', marginBottom:'8px', fontWeight:600}}>Ponto de Referência</Form.Label>
                <Form.Control
                  type="text"
                  value={referencia}
                  onChange={(e) => setReferencia(e.target.value)}
                  placeholder="Ex: Aos fundos do mercado, casa vermelha."
                  style={{
                    fontSize:'0.85rem',
                    padding:'10px 12px',
                    borderRadius:'12px',
                    border:'1px solid #e5e7eb',
                    backgroundColor:'#fff'
                  }}
                />
              </Form.Group>
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer style={{gap:'12px', display:'flex', borderTop:'1px solid #e5e7eb', padding:'16px 20px'}}>
        <Button 
          variant="outline-secondary" 
          onClick={handleClose} 
          disabled={loading}
          className="flex-grow-1 btn-cancel-light"
          style={{
            padding: '12px',
            borderRadius: '12px',
            fontSize: '0.9rem',
            border: '1px solid #e5e7eb',
            color: '#6b7280',
            backgroundColor: 'white'
          }}
        >
          Cancelar
        </Button>
        <Button 
          variant="primary" 
          onClick={handleSalvar}
          disabled={!enderecoSelecionado || loading}
          className="flex-grow-1 btn-primary-glow"
          style={{
            padding: '12px',
            borderRadius: '12px',
            backgroundColor: loading ? '#0056cc' : '#0039ff',
            border: 'none',
            fontSize: '0.9rem',
            fontWeight: '600',
            boxShadow: '0 4px 12px rgba(0,106,255,0.25)',
            opacity: !enderecoSelecionado ? 0.5 : 1
          }}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Salvando...
            </>
          ) : (
            'Salvar Endereço'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AdicionarEnderecoModal;
